import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const SlingOrganizationSchema = z.object({
  slingOrgId: z.number(),
  name: z.string(),
  connected: z.boolean(),
});

const SlingConnectionStatusResponseDtoSchema = z.object({
  setUp: z.boolean(),
  connected: z.boolean(),
  /** The saved login, masked by the server. The password is never sent. */
  email: z.string().nullable(),
  organizations: z.array(SlingOrganizationSchema),
  lastSyncedAt: z.string().nullable(),
});

const SaveSlingConnectionRequestDtoSchema = z.object({
  email: z.string(),
  password: z.string(),
});

const SaveSlingConnectionResponseDtoSchema = z.object({
  outcome: z.enum(['saved', 'not-set-up']),
  message: z.string(),
  visibleOrganizations: z.array(
    z.object({ slingOrgId: z.number(), name: z.string() })
  ),
  organizations: z.array(
    SlingOrganizationSchema.extend({ visibleToLogin: z.boolean() })
  ),
});

export type SlingConnectionStatusResponseDto = z.infer<
  typeof SlingConnectionStatusResponseDtoSchema
>;
export type SaveSlingConnectionRequestDto = z.infer<
  typeof SaveSlingConnectionRequestDtoSchema
>;
export type SaveSlingConnectionResponseDto = z.infer<
  typeof SaveSlingConnectionResponseDtoSchema
>;

export const getSlingConnectionStatus = (config?: AxiosRequestConfig) =>
  api
    .get('/sling/connection/status', config)
    .then(responseContract(SlingConnectionStatusResponseDtoSchema));

export const saveSlingConnection = (
  dto: SaveSlingConnectionRequestDto,
  config?: AxiosRequestConfig<SaveSlingConnectionRequestDto>
) =>
  api
    .post(
      '/sling/connection/save-and-test',
      SaveSlingConnectionRequestDtoSchema.parse(dto),
      config
    )
    .then(responseContract(SaveSlingConnectionResponseDtoSchema));
